import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement } from './endpoints';
import axiosBaseQueryUserMangement from './axiosBaseQueryUserMangement';
// import { Pokemon } from './types';

// Define a service using a base URL and expected endpoints
export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: axiosBaseQueryUserMangement({ baseUrl: process.env.REACT_APP_USER_MANAGEMENT_BASE_URL }),
  tagTypes: ['user'],
  endpoints: (builder) => ({
    addUser: builder.mutation({
      query(body) {
        return {
          url: userManagement.userController.addUser,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    findUserById: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.userController.findUserById}${body.id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    resetPassword: builder.mutation({
      query(body) {
        return {
          url: userManagement.userController.resetPassword,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    findUsersByCategory: builder.mutation({
      query(body) {
        return {
          url: userManagement.userController.findUsersByCategory,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateUser: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.userController.updateUser}${body.payload.id}`,
          headers: { Authorization: `Bearer ${body.token}` },
          method: 'PUT',
          body: body.payload,
        };
      },
    }),
    forgotPassword: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.userController.forgotPassword}/${body.email}/${body.category}`,
          method: 'PUT',
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {useFindUsersByCategoryMutation,useAddUserMutation, useFindUserByIdMutation, useResetPasswordMutation, useUpdateUserMutation, useForgotPasswordMutation } =
  userApi;
